// Angular
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()

export class FormsService {

    constructor() {
    }

    validate(formGroup: FormGroup, controlName: string): boolean {
        return formGroup.controls[controlName].invalid && formGroup.controls[controlName].touched;
    }


    validateWithoutTouch(formGroup: FormGroup, controlName: string): boolean {
        return formGroup.controls[controlName].invalid;
    }
}
